import { gql } from '@apollo/client';
import { ACTIVITY_FEED_FRAGMENT } from './acitivity-feed.fragments';

export const GET_ACTIVITY_QUERY = gql`
  query GetActivityFeed($params: GetActivityFeedInput) {
    getActivityFeed(params: $params) {
      records {
        ...ActivityFeedFields
      }
    }
  }
  ${ACTIVITY_FEED_FRAGMENT}
`;
